import { useState } from 'react';
import { VRSTE_DOKUMENATA } from '../lib/dokumenti';
import OdabirDokumenata from './OdabirDokumenata';
import PopisDokumenata from './PopisDokumenata';
import Ikona from './Ikona';
export default function Dokumenti({
  stanje,
  kucanstva,
  pocetnoKucanstvoId,
  jeUprava,
  korisnikId,
  naPosalji,
  naPreuzmi,
  naArhiviraj,
  naNovo,
}) {
  const dostupna = kucanstva;
  const [kucanstvoId, postaviKucanstvoId] = useState(
    pocetnoKucanstvoId
      ? String(pocetnoKucanstvoId)
      : jeUprava
        ? ''
        : String(dostupna[0]?.id || ''),
  );
  const [vrsta, postaviVrstu] = useState(
    pocetnoKucanstvoId ? 'gdpr_privola' : 'ostalo',
  );
  const [naziv, postaviNaziv] = useState('');
  const [datum, postaviDatum] = useState('');
  const [datoteke, postaviDatoteke] = useState([]);
  const [radi, postaviRadi] = useState(false);
  const [priprema, postaviPriprema] = useState(false);
  const [poruka, postaviPoruku] = useState(null);
  const [napredak, postaviNapredak] = useState('');
  const [pokusano, postaviPokusano] = useState(false);
  const [upit, postaviUpit] = useState('');
  const [filter, postaviFilter] = useState('');
  const [arhiva, postaviArhiva] = useState(false);
  const [samoKucanstvo, postaviSamoKucanstvo] = useState(!!pocetnoKucanstvoId);
  const danas = new Intl.DateTimeFormat('sv-SE', {
    timeZone: 'Europe/Zagreb',
  }).format(new Date());
  const prikazani = stanje.dokumenti.filter(
    (d) =>
      d.arhivirano === arhiva &&
      (!filter || d.vrsta === filter) &&
      (!samoKucanstvo || d.kucanstvo_id === pocetnoKucanstvoId) &&
      `${d.naziv} ${d.izvorni_naziv} ${kucanstva.find((k) => k.id === d.kucanstvo_id)?.adresa || ''}`
        .toLocaleLowerCase('hr')
        .includes(upit.toLocaleLowerCase('hr')),
  );
  const posalji = async (e) => {
    e.preventDefault();
    if (radi || priprema) return;
    if (!datoteke.length) {
      postaviPoruku({
        greska: true,
        tekst: 'Najprije fotografiraj dokument ili odaberi datoteku.',
      });
      return;
    }
    if ((!jeUprava || vrsta === 'gdpr_privola') && !kucanstvoId) {
      postaviPoruku({
        greska: true,
        tekst: 'Odaberi kućanstvo kojem pripada dokument.',
      });
      return;
    }
    if (datum && datum > danas) {
      postaviPoruku({
        greska: true,
        tekst: 'Datum potpisivanja ne može biti u budućnosti.',
      });
      return;
    }
    postaviRadi(true);
    postaviPokusano(true);
    postaviPoruku(null);
    try {
      const rezultat = await naPosalji({
        datoteke,
        kucanstvoId: kucanstvoId ? Number(kucanstvoId) : null,
        vrsta,
        naziv,
        datumPrivole: datum,
        naNapredak: postaviNapredak,
      });
      postaviDatoteke([]);
      postaviNaziv('');
      postaviDatum('');
      postaviPokusano(false);
      postaviPoruku({
        tekst: `Spremljeno: ${rezultat.poslano}. Već priloženo: ${rezultat.ponovljeno}. Dokumenti su dostupni u popisu.`,
      });
    } catch (e) {
      postaviPoruku({
        greska: true,
        tekst: `${e.message} Već poslane datoteke sačuvane su. Ponovi slanje bez duplikata.`,
      });
    } finally {
      postaviRadi(false);
      postaviNapredak('');
      await stanje.osvjezi();
    }
  };
  return (
    <div className="stranica-dokumenata">
      <div className="uvod-unosa">
        <Ikona naziv="lokot" />
        <p>
          {jeUprava
            ? 'Privatna arhiva uprave i prilozi kućanstava.'
            : 'Popisivači imaju pristup prilozima svih kućanstava.'}{' '}
          Privole nisu dostupne običnim korisnicima.
        </p>
      </div>
      <section className="ploca novi-dokument">
        <div className="naslov-dokumenata">
          <span className="ikona-ploha tirkiz">
            <Ikona naziv="dokument" />
          </span>
          <div>
            <h2>Dodaj dokument</h2>
            <p>Fotografiraj na terenu ili priloži već skeniranu datoteku.</p>
          </div>
        </div>
        {!jeUprava && !dostupna.length ? (
          <p>
            Prvo unesi kućanstvo kako bi mu mogao/la priložiti dokument.{' '}
            <button className="tekst-gumb" onClick={naNovo}>
              Novo kućanstvo
            </button>
          </p>
        ) : (
          <form onSubmit={posalji}>
            <fieldset disabled={radi || pokusano} className="polja-dokumenta">
              <label>
                Naziv dokumenta
                <input
                  value={naziv}
                  onChange={(e) => postaviNaziv(e.target.value)}
                  maxLength={200}
                  placeholder="Ako je prazno, koristit će se naziv datoteke"
                />
              </label>
              <label>
                Vrsta dokumenta
                <select
                  value={vrsta}
                  onChange={(e) => postaviVrstu(e.target.value)}
                >
                  {Object.entries(VRSTE_DOKUMENATA).map(([v, n]) => (
                    <option key={v} value={v}>
                      {n}
                    </option>
                  ))}
                </select>
              </label>
              <label>
                Kućanstvo {(!jeUprava || vrsta === 'gdpr_privola') && '*'}
                <select
                  value={kucanstvoId}
                  onChange={(e) => postaviKucanstvoId(e.target.value)}
                >
                  <option value="">
                    {jeUprava && vrsta !== 'gdpr_privola'
                      ? 'Opći dokument vodovoda'
                      : 'Odaberi kućanstvo'}
                  </option>
                  {dostupna.map((k) => (
                    <option key={k.id} value={k.id}>
                      {k.adresa}
                    </option>
                  ))}
                </select>
              </label>
              {vrsta === 'gdpr_privola' && (
                <label>
                  Datum potpisivanja (ako je poznat)
                  <input
                    type="date"
                    value={datum}
                    max={danas}
                    onChange={(e) => postaviDatum(e.target.value)}
                  />
                </label>
              )}
            </fieldset>
            <OdabirDokumenata
              datoteke={datoteke}
              naPromjenu={postaviDatoteke}
              zauzeto={radi || pokusano}
              naPripremu={postaviPriprema}
            />
            {poruka && (
              <p
                className={`obavijest ${poruka.greska ? 'greska' : 'ok'}`}
                role={poruka.greska ? 'alert' : 'status'}
              >
                {poruka.tekst}
              </p>
            )}
            {vrsta === 'gdpr_privola' && (
              <p className="pomoc-dokumenata">
                Priloži potpisani dokument. Samo spremanje snimke ne potvrđuje
                sadržaj ni valjanost privole.
              </p>
            )}
            <div className="radnje-obrasca">
              <button
                className="gumb"
                disabled={radi || priprema}
                type="submit"
              >
                {napredak || (pokusano ? 'Ponovi slanje' : 'Spremi dokumente')}
              </button>
              {pokusano && !radi && (
                <button
                  className="tekst-gumb"
                  type="button"
                  onClick={() => {
                    postaviDatoteke([]);
                    postaviPokusano(false);
                    postaviPoruku(null);
                  }}
                >
                  Započni novi odabir
                </button>
              )}
            </div>
          </form>
        )}
      </section>
      <section className="ploca arhiva-dokumenata">
        <div className="naslov-dokumenata">
          <div>
            <h2>
              {pocetnoKucanstvoId && samoKucanstvo
                ? `Dokumenti · ${kucanstva.find((k) => k.id === pocetnoKucanstvoId)?.adresa || 'kućanstvo'}`
                : 'Arhiva dokumenata'}
            </h2>
            <p>
              {
                stanje.dokumenti.filter(
                  (d) => d.stanje === 'spremno' && !d.arhivirano,
                ).length
              }{' '}
              spremljenih priloga · pristup prema ovlastima
            </p>
          </div>
          <button className="tekst-gumb" onClick={stanje.osvjezi}>
            Osvježi
          </button>
        </div>
        <div className="filtri-dokumenata">
          <label>
            Traži dokument
            <input
              type="search"
              value={upit}
              onChange={(e) => postaviUpit(e.target.value)}
              placeholder="Naziv ili adresa"
            />
          </label>
          <label>
            Vrsta
            <select
              value={filter}
              onChange={(e) => postaviFilter(e.target.value)}
            >
              <option value="">Sve vrste</option>
              {Object.entries(VRSTE_DOKUMENATA).map(([v, n]) => (
                <option key={v} value={v}>
                  {n}
                </option>
              ))}
            </select>
          </label>
          <label className="redak-kvacice">
            <input
              type="checkbox"
              checked={arhiva}
              onChange={(e) => postaviArhiva(e.target.checked)}
            />{' '}
            Arhivirani
          </label>
          {pocetnoKucanstvoId && (
            <label className="redak-kvacice">
              <input
                type="checkbox"
                checked={samoKucanstvo}
                onChange={(e) => postaviSamoKucanstvo(e.target.checked)}
              />{' '}
              Samo ovo kućanstvo
            </label>
          )}
        </div>
        <PopisDokumenata
          dokumenti={prikazani}
          kucanstva={kucanstva}
          korisnikId={korisnikId}
          jeUprava={jeUprava}
          naPreuzmi={naPreuzmi}
          naArhiviraj={naArhiviraj}
          ucitava={stanje.ucitava}
          greska={stanje.greska}
          naOsvjezi={stanje.osvjezi}
        />
      </section>
    </div>
  );
}
